// extracted by mini-css-extract-plugin
export default {"l_ExtensionItem_main":"ExtensionItem_l_ExtensionItem_main__IJv2V"};